























import Vue from "vue";

export default Vue.extend({
  name: "SkillCompletionGraph",
  props: {
    completion: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    this.completionPercent();
  },
  methods: {
    completionPercent() {
      const percent = this.completion;

      const circle: any = this.$refs.circle;
      if (!circle.r) {
        return;
      }
      const radius = circle.r.baseVal.value;
      const circumference = radius * 2 * Math.PI;
      circle.style.strokeDasharray = `${circumference} ${circumference}`;
      circle.style.strokeDashoffset = `${circumference}`;
      circle.style.strokeDashoffset = circumference - (percent / 100) * circumference;
    }
  },
  watch: {
    completion() {
      this.completionPercent();
    }
  }
});
